import styled from "styled-components";
import {LogOutLinkDefaultBox} from "./log-out-link.default.box";

export const LogOutLinkMrGreenBox = styled(LogOutLinkDefaultBox)`
    &:hover {
        background-color: ${props => props.theme.colors.background};
    }
`;
